// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-6i7","footer":"styles_footer__3D2Ac","passCodeTooltip":"styles_passCodeTooltip__27Ux7"};